import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { convertDollarPriceToCents } from 'lib/money'
import { KLARNA_TIER_HASH, KLARNA_TIER_ID } from 'shared/constants'
import { InfoIconOutline } from 'components/icons'
import {
  AfterpayInfoModalContent,
  AfterpayLogo,
  KlarnaLogo,
} from './vendor-assets'
import LearnMoreWrapperModal from './learn-more-wrapper-modal'
import * as css from './deferred-payment-message.scss'

const PaymentMethodNameWrapper = ({
  logo,
  learnMoreModalClassName,
  learnMoreModalContent,
}) => {
  const [showInfoModal, setShowInfoModal] = useState(false)

  return (
    <>
      <span
        className="flex align-end"
        role="none"
        onClick={() => setShowInfoModal(true)}
      >
        {logo}
        <InfoIconOutline className={css.infoIcon} />
      </span>
      <LearnMoreWrapperModal
        className={learnMoreModalClassName}
        show={showInfoModal}
        onHide={() => setShowInfoModal(false)}
      >
        {learnMoreModalContent}
      </LearnMoreWrapperModal>
    </>
  )
}

PaymentMethodNameWrapper.propTypes = {
  logo: PropTypes.node.isRequired,
  learnMoreModalClassName: PropTypes.string.isRequired,
  learnMoreModalContent: PropTypes.node.isRequired,
}

const AfterpayBadge = () => (
  <PaymentMethodNameWrapper
    logo={<AfterpayLogo />}
    learnMoreModalClassName={css.afterpayLearnMoreModal}
    learnMoreModalContent={<AfterpayInfoModalContent />}
  />
)

const KlarnaBadge = ({ price }) => {
  const klarnaHostedContentConfig = {
    country: 'US',
    isThreshold: false,
    language: 'EN',
    paymentMethodId: 9,
    purchaseAmount: convertDollarPriceToCents(price) || null,
    tierHash: KLARNA_TIER_HASH,
    tierId: KLARNA_TIER_ID,
  }
  const configHash = Buffer.from(
    JSON.stringify(klarnaHostedContentConfig)
  ).toString('base64')
  const klarnaHostedContentURL = `https://na-assets.klarnaservices.com/learn-more/index.html?showButtons=false&showBackground=false#${configHash}`

  return (
    <PaymentMethodNameWrapper
      logo={<KlarnaLogo />}
      learnMoreModalClassName={css.klarnaLearnMoreModal}
      learnMoreModalContent={
        <iframe
          className="klarna-upstream-interstitial-frame"
          title="Learn more dialog"
          role="none"
          src={klarnaHostedContentURL}
        />
      }
    />
  )
}

KlarnaBadge.propTypes = {
  price: PropTypes.number.isRequired,
}

export { AfterpayBadge, KlarnaBadge }
